import { useCallback, useState } from 'react';
import { riderStatusApi } from '../api/riderStatusApi';
import type { RiderFilter, RiderFilterState } from '../types/riderStatus.types';
import { getItem } from '@/shared/utils/storage';
import { ToastType } from '@/shared/components/feedback/Toast/Toast.types';
import { useToast } from '@/shared/components/feedback/Toast/ToastContext';

export const useRiderExcel = (filters: RiderFilterState) => {
    const { showToast } = useToast();
    const userType = getItem<string>('USER_TYPE');
    const userId = getItem<string>('USER_ID');
    const [excelDownloading, setExcelDownloading] = useState(false);

    const handleExcelDownload = useCallback(async (): Promise<void> => {
        try {
            setExcelDownloading(true);
            showToast('엑셀 다운로드를 시작합니다...', { type: ToastType.INFO });

            const raw = { ...filters };
            if (userType === 'SUPPLIER' && userId) raw.centerId = userId;

            const clean: RiderFilter = {};
            if (raw.centerId) clean.centerId = raw.centerId;
            if (raw.riderName) clean.riderName = raw.riderName;
            if (raw.riderId) clean.riderId = raw.riderId;
            if (raw.phoneNum) clean.phoneNum = raw.phoneNum;
            if (raw.contStatus) clean.contStatus = raw.contStatus;

            const blob = await riderStatusApi.downloadRiderStatusExcel(clean);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `라이더현황_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            showToast('엑셀 다운로드가 완료되었습니다.', { type: ToastType.SUCCESS });
        } catch {
            showToast('엑셀 다운로드에 실패했습니다.', { type: ToastType.ERROR });
        } finally {
            setExcelDownloading(false);
        }
    }, [filters, userType, userId, showToast]);

    return { excelDownloading, handleExcelDownload };
};
